import { resourceQueryParamName } from 'constants/resourceQueryNames';
import { useNavParamsByResource } from 'hooks/nav/useNavParamsByResource';
import { RequestParamsType, RequestResponse } from 'hooks/types/client';
import { useParams } from 'react-router-dom';
import type { RouteParams, UUID } from 'types';
import useRequest from '../client/useRequest';

type Options = {
  redirectOnError?: boolean;
  enabled?: boolean;
  queryParamsOverride?: RouteParams;
};

type UseAgentSessions = (
  investigationId?: UUID,
  options?: Options
) => RequestResponse<'investigations.extras.getAgentSessions'>;

const useAgentSessions: UseAgentSessions = (investigationId, options) => {
  const { investigationId: routeInvestigationId } = useParams<{ investigationId: string }>();
  const id = investigationId ?? routeInvestigationId;
  const resourceParams = useNavParamsByResource(resourceQueryParamName.agentSessions);

  const params: RequestParamsType = {
    urlParams: { investigationId: id ?? '' },
    queryParams: {
      ...resourceParams,
      ...(options?.queryParamsOverride ?? {}),
      include_count: true,
    },
    redirectOnError: options?.redirectOnError,
  };

  return useRequest('investigations.extras.getAgentSessions', params, {
    enabled: options?.enabled ?? true,
  });
};

export default useAgentSessions;
